/** The established public-donate host mapping, shared by the two console adapters. */
export function donateWebBaseUrl(environment: string | undefined): string {
  const env = environment?.trim().toLowerCase();
  if (env === 'prod') return 'https://donate.givmo.io';
  if (env === 'staging') return 'https://donate-staging.givmo.io';
  return 'https://donate-dev.givmo.io';
}
